import type { LotoPageDetails } from './lotoPageLookups'
import {
  type LotoDrawingLabel,
  lotoDrawingLabels,
  lotoPointTags,
} from './lotoReportCoverage'
import type { LotoReportEntry } from './lotoReportSchemas'
import {
  equipmentSystemText,
  targetEquipmentLabels,
} from './lotoTargetEquipment'

export type LotoReportSummary = {
  id: string
  name: string
  lotoIndex: string
  equipmentSystem: string
  targetEquipment: string[]
  reason: string
  pageCount: number
  pointTags: string[]
  drawings: LotoDrawingLabel[]
  createdAt: string
  editedAt: string | undefined
  editedBy: string | undefined
}

function summarize(
  { id, data, updated_at, last_updated_by }: LotoReportEntry,
  pageDetails: LotoPageDetails | undefined
): LotoReportSummary {
  return {
    id,
    name: data.name,
    lotoIndex: data.loto_index,
    equipmentSystem: equipmentSystemText(data),
    targetEquipment: targetEquipmentLabels(data.target_equipment),
    reason: data.reason,
    pageCount: data.attachments.reduce(
      (total, { page_ids }) => total + page_ids.length,
      0
    ),
    pointTags: lotoPointTags(data.isolation_points),
    drawings: lotoDrawingLabels(data.attachments, pageDetails),
    createdAt: data.created_at,
    editedAt: updated_at ?? undefined,
    editedBy: last_updated_by || undefined,
  }
}

function lastChangedAt({ editedAt, createdAt }: LotoReportSummary): number {
  return Date.parse(editedAt ?? createdAt)
}

export function summarizeLotoReports(
  entries: LotoReportEntry[],
  pageDetails?: LotoPageDetails
): LotoReportSummary[] {
  return entries
    .map((entry) => summarize(entry, pageDetails))
    .sort((a, b) => lastChangedAt(b) - lastChangedAt(a))
}
